import React from 'react';
import { BsXLg } from 'react-icons/bs';

import LaunchpadWidgetWrapper from '../../LaunchpadWidgetWrapper';
import '../Widgets.scss';

interface HeaderWidgetProps {
	headerTitle?: string;
	headerDescription?: string;
	headerImageUrl?: string;
	widgetDetails?: any;
	widgets?: any[];
	editMode?: boolean;
	handleClose?: () => void;
	setWidgets?: (widgets: any[]) => void;
	setSnackbar?: (snackbar: any) => void;
	t: (key: string) => string;
	isHeaderWidget?: boolean;
	currentBreakpoint?: string;
	isInPreviewMode?: boolean;
	setIsInPreviewMode?: (isPreview: boolean) => void;
	setWidgetCustomizationData?: (data: any) => void;
	setHeaderImageUrl?: (url: any) => void;
	widgetCustomizationData?: {
		headerImage?: string;
		headerTitle?: string;
		headerTitleDescription?: string;
	};
	widgetFinishStatus?: any;
	setWidgetFinishStatus?: (status: any) => void;
	launchpadSettingsData?: any;
	editModalInputFields?: any;
	setEditModalInputFields?: (fields: any) => void;
	isLoading?: boolean;
	selectLaunchpadSettingsData?: any;
}

const HeaderWidget: React.FC<HeaderWidgetProps> = ({
	headerTitle = '',
	headerDescription = '',
	headerImageUrl = '',
	widgetDetails = [],
	widgets = [],
	editMode = false,
	handleClose = () => {},
	setWidgets = () => {},
	setSnackbar = () => {},
	t,
	isHeaderWidget,
	currentBreakpoint = '',
	isInPreviewMode,
	setIsInPreviewMode = () => {},
	setWidgetCustomizationData = () => {},
	setHeaderImageUrl = () => {},
	widgetCustomizationData,
	widgetFinishStatus,
	setWidgetFinishStatus = () => {},
	launchpadSettingsData,
	editModalInputFields,
	setEditModalInputFields = () => {},
	isLoading = false,
	selectLaunchpadSettingsData,
}) => {
	const isMobile = ['sm', 'xs', 'xxs', 'xxxs'].includes(currentBreakpoint);
	const closeButtonBreakpoints = ['md', 'sm', 'xs', 'xxs', 'xxxs'].includes(
		currentBreakpoint,
	);

	return (
		<LaunchpadWidgetWrapper
			{...{
				editModalInputFields,
				editMode,
				headerWidgetDescription: headerDescription,
				headerWidgetImageUrl: headerImageUrl,
				headerWidgetTitle: headerTitle,
				hideHeader: true,
				isHeaderWidget,
				isInPreviewMode,
				isThemeSelectable: false,
				isTitleBlock: false,
				launchpadSettingsData,
				selectLaunchpadSettingsData,
				setEditModalInputFields,
				setHeaderImageUrl,
				setIsInPreviewMode,
				setSnackbar,
				setWidgetCustomizationData,
				setWidgetFinishStatus,
				setWidgets,
				t,
				widgetCustomizationData,
				widgetDetails,
				widgetFinishStatus,
				widgets,
				wrapperClassNames: 'border-0',
			} as any}
		>
			<div className="header-content shadow-none border-0 d-flex flex-column flex-sm-row align-items-center gap-3">
				{!isLoading &&
				!isMobile &&
				((isInPreviewMode && widgetCustomizationData?.headerImage) ||
					headerImageUrl) ? (
					<img
						alt="header"
						className="header-image"
						src={
							isInPreviewMode
								? widgetCustomizationData?.headerImage
								: headerImageUrl
						}
					/>
				) : null}
				<div className="d-flex flex-column gap-2">
					{isLoading ? (
						<div className="d-flex flex-column">
							<h1 className="fs-1 mb-2 text-capitalize">{t('launchpad')}</h1>
							<p className="fw-normal mb-0 fs-6 lh-sm">
								{t('launchpadDescription')}
							</p>
						</div>
					) : (
						<>
							{widgetCustomizationData?.headerTitle || headerTitle ? (
								<h1 className="fs-1 mb-2 text-capitalize">
									{isInPreviewMode
										? widgetCustomizationData?.headerTitle
										: headerTitle}
								</h1>
							) : null}
							{widgetCustomizationData?.headerTitleDescription ||
							headerDescription ? (
								<p className="fw-normal mb-0 fs-6 lh-sm">
									{isInPreviewMode
										? widgetCustomizationData?.headerTitleDescription
										: headerDescription}
								</p>
							) : null}
						</>
					)}
				</div>
				{closeButtonBreakpoints && (
					<button
						className="close-button closebutton bg-white p-0 border-0 d-flex align-items-center justify-content-center position-absolute"
						style={{ top: -32, right: -16 }}
						onClick={handleClose}
					>
						<BsXLg />
					</button>
				)}
			</div>
		</LaunchpadWidgetWrapper>
	);
};

export default HeaderWidget;
